'use client';
import PredicQuery from '@/components/predic/ui/PredicQuery';
import Trending from '@/components/predic/trending/Trending';
import Discover from '@/components/predic/trending-markets/TrendingMarkets';

export default function PredicPage() {
  return (
    <div className="relative">
      <div className="relative z-1 max-w-245 mx-auto pb-30 space-y-8">
        <PredicQuery />
        <Trending />
        <Discover wrapperClassName="grid grid-cols-2 gap-3" />
      </div>
    </div>
  );
}
